<mat-form-field appearance="outline" class="min-part">
  <mat-label>{{ label | translate }}</mat-label>
  <input matInput type="number" [(ngModel)]="value" (ngModelChange)="emitValue()" />
</mat-form-field>
